import { useState, useRef, useCallback } from 'react';
import STATUS_CODES from '@zola-helpers/client/dist/es/http/statusCodes';
import { ErrorType } from '@zola-helpers/client/dist/es/redux/auth/authActions';

const TIMEOUT = 10000;

export const useAuthErrorHandler = (): [
  string | undefined,
  (response: ErrorType) => void,
  boolean
] => {
  const [errorMessage, setErrorMessage] = useState<string>();
  const [preventSubmit, setPreventSubmit] = useState<boolean>(false);
  const timer = useRef<number>();

  const handleError = useCallback((response: ErrorType) => {
    if (response?.response?.status === STATUS_CODES.TOO_MANY_REQUESTS) {
      setPreventSubmit(true);
      timer.current = window.setTimeout(() => {
        setPreventSubmit(false);
        setErrorMessage('Please try again.');
      }, TIMEOUT);
    }

    setErrorMessage(response.detailedMessage);
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  return [errorMessage, handleError, preventSubmit];
};

export default useAuthErrorHandler;
